import axios, { AxiosRequestConfig } from "axios";

import { handleDates } from "./handleDates";

const DEFAULT_HEADERS = {
    accept: "application/json",
    "content-type": "application/json",
};

export const axiosFactory = () => {
    const client = axios.create({
        headers: { ...DEFAULT_HEADERS },
        responseType: "json",
        baseURL: window.$cp?.backendUrl,
        timeout: 30_000,
    });

    client.interceptors.request.use((config: AxiosRequestConfig) => {
        const headers = {
            "Accept-Language": window.$language,
            "X-Frontend-Location": window.location.origin + window.location.pathname,
        };

        config.headers = { ...headers, ...config.headers };
        return config;
    }, Promise.reject);

    client.interceptors.response.use(
        (response) => {
            return handleDates(response);
        },
        (error) => {
            const { request, response } = error;

            if (!request) {
                return Promise.reject(error);
            }

            if (!response) {
                return Promise.reject(error);
            }

            return Promise.reject(error);
        },
    );

    return client;
};
